import { markRaw } from 'vue'
import type { RegisteredComponent } from '@builder.io/sdk-vue'
import BaseTabViewHeroLike from '~/components/BaseTabViewHeroLike.vue'

export default <RegisteredComponent>{
  name: 'Base Tab View Hero Like',
  tag: 'base-tab-hero-like-comp',
  type: 'vue',
  component: markRaw(BaseTabViewHeroLike),
  inputs: [
    {
      name: 'items',
      friendlyName: 'List of items to show (bound data)',
      helperText:
        'This is the list of items. Make sure to bind it through Visual Editor (model: tab-view-data-hero-like)',
      type: 'list',
      defaultValue: [
        {
          navTitle: 'What is Lorem Ipsum?',
          title: 'What is Lorem Ipsum?',
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
          linkText: 'Learn more',
          linkUrl: '/',
          isLinkExternal: false,
          imageSrc: 'https://picsum.photos/200/300',
        },
      ],
      subFields: [
        { name: 'navTitle', type: 'string' },
        { name: 'title', type: 'string' },
        { name: 'description', type: 'string' },
        { name: 'linkText', type: 'string' },
        {
          name: 'linkUrl',
          type: 'string',
        },
        { name: 'isLinkExternal', type: 'boolean' },
        {
          name: 'imageSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg', 'webp'],
        },
      ],
    },

    {
      name: 'orientation',
      friendlyName: 'The Orientation of the Tab View',
      helperText: 'This determines the tab view layout',
      type: 'string',
      defaultValue: 'horizontal',
      enum: ['horizontal', 'vertical'],
    },
  ],
}
